export default __webpack_public_path__ + "static/media/featured3-1.c851a79a.jpg";